'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _gridUtils = require('../../../utils/grid/gridUtils');

var _RichMediaPreviewOverlay = require('./RichMediaPreviewOverlay');

var _RichMediaPreviewOverlay2 = _interopRequireDefault(_RichMediaPreviewOverlay);

var _RichMediaErrorOverlay = require('./RichMediaErrorOverlay');

var _RichMediaErrorOverlay2 = _interopRequireDefault(_RichMediaErrorOverlay);

var _Spinner = require('../../../components/loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _ResponsiveProgressiveBackgroundImage = require('../../../components/images/ResponsiveProgressiveBackgroundImage');

var _ResponsiveProgressiveBackgroundImage2 = _interopRequireDefault(_ResponsiveProgressiveBackgroundImage);

var _mediaConstants = require('../../../../common/media/mediaConstants');

require('./RichMediaPreviewImage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants


// Components
// Lib
var getHeight = function getHeight(_ref) {
    var mediaData = _ref.mediaData;

    if (!mediaData) return;

    var ratio = mediaData.get('height') / mediaData.get('width');

    return {
        paddingBottom: Math.floor(ratio * 100) + '%'
    };
};

// Styles


// Utils


var RichMediaPreviewImage = function RichMediaPreviewImage(props) {
    var imageData = props.imageData,
        mediaData = props.mediaData,
        width = props.width,
        gridSize = props.gridSize,
        onClick = props.onClick,
        show = props.show,
        showLoader = props.showLoader,
        showError = props.showError,
        previewIconName = props.previewIconName,
        _props$OverlayCompone = props.OverlayComponent,
        OverlayComponent = _props$OverlayCompone === undefined ? _RichMediaPreviewOverlay2.default : _props$OverlayCompone;


    var widthPx = (0, _gridUtils.gridPointsToPixels)(width, gridSize);

    if (!show) return null;

    var imageElement = imageData ? _react2.default.createElement(_ResponsiveProgressiveBackgroundImage2.default, { imageType: _mediaConstants.IMAGE_TYPES.ELEMENT,
        imageDetails: imageData, size: widthPx }) : null;

    var previewImageClassNames = (0, _classnames2.default)('RichMediaPreviewImage', { loading: showLoader });

    return _react2.default.createElement(
        'div',
        { className: previewImageClassNames, style: getHeight({ mediaData: mediaData, widthPx: widthPx }) },
        imageElement,
        _react2.default.createElement(OverlayComponent, { show: !showLoader && !showError, onClick: onClick, iconName: previewIconName }),
        _react2.default.createElement(_Spinner2.default, { show: showLoader }),
        _react2.default.createElement(_RichMediaErrorOverlay2.default, { show: showError })
    );
};

RichMediaPreviewImage.propTypes = {
    element: _propTypes2.default.object.isRequired,
    imageData: _propTypes2.default.object,
    mediaData: _propTypes2.default.object,
    width: _propTypes2.default.number,
    gridSize: _propTypes2.default.number,
    enablePlayer: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    show: _propTypes2.default.bool,
    showLoader: _propTypes2.default.bool,
    showError: _propTypes2.default.bool,
    previewIconName: _propTypes2.default.string,
    OverlayComponent: _propTypes2.default.func
};

exports.default = RichMediaPreviewImage;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/RichMediaPreviewImage.js
// module id = 2012
// module chunks = 0